import Vue from "vue";
import Vuex from "vuex";
import common from "./modules/common";
import authData from "./modules/authData";
import user from "./modules/user";
import home from "./modules/home";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    common,
    authData,
    user,
    home
  },
  plugins: [
    createPersistedState({
      key: 'user',
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    }),
  ],
});



// WEBPACK FOOTER //
// ./src/store/index.js